import { createReducer } from 'deox';
import { produce } from 'immer';

import {
  createArtwork,
  setArtwork,
  resetErrors,
  resetArtwork,
  deleteArtwork,
  updateArtwork,
} from './actions';
import { ArtworkState } from './types';

const initialState: ArtworkState = {
  creating: false,
  deleting: false,
  error: null,
  previewMode: false,
  data: null,
};

export const artworkReducer = createReducer(initialState, (handleAction) => [
  handleAction(createArtwork.request, (state) =>
    produce(state, (draft) => {
      draft.creating = true;
      draft.error = null;
    }),
  ),
  handleAction(createArtwork.success, (state, { payload }) =>
    produce(state, (draft) => {
      draft.creating = false;
      draft.data = payload;
      draft.previewMode = true;
    }),
  ),
  handleAction(createArtwork.fail, (state, { payload }) =>
    produce(state, (draft) => {
      draft.creating = false;
      draft.error = payload.message;
    }),
  ),
  handleAction(setArtwork, (state, { payload }) =>
    produce(state, (draft) => {
      draft.data = payload.artwork;
      draft.previewMode = payload.previewMode;
    }),
  ),
  handleAction(resetErrors, (state) =>
    produce(state, (draft) => {
      draft.error = null;
    }),
  ),
  handleAction(resetArtwork, (state) =>
    produce(state, (draft) => {
      draft.data = null;
      draft.previewMode = false;
    }),
  ),
  handleAction(deleteArtwork.request, (state) =>
    produce(state, (draft) => {
      draft.deleting = true;
      draft.error = null;
    }),
  ),
  handleAction(deleteArtwork.success, (state) =>
    produce(state, (draft) => {
      draft.deleting = false;
    }),
  ),
  handleAction(deleteArtwork.fail, (state, { payload }) =>
    produce(state, (draft) => {
      draft.deleting = false;
      draft.error = payload.message;
    }),
  ),
  handleAction(updateArtwork.request, (state) =>
    produce(state, (draft) => {
      draft.creating = true;
      draft.error = null;
    }),
  ),
  handleAction(updateArtwork.success, (state, { payload }) =>
    produce(state, (draft) => {
      draft.creating = false;
      draft.data = payload;
    }),
  ),
  handleAction(updateArtwork.fail, (state, { payload }) =>
    produce(state, (draft) => {
      draft.creating = false;
      draft.error = payload.message;
    }),
  ),
]);
